module.exports = __webpack_public_path__ + "img/D202203_2.6c696c04.jpg";